import {ApplicationConfig, ErrorHandler, importProvidersFrom} from '@angular/core';
import {HttpClient, provideHttpClient} from '@angular/common/http';
import {provideRouter} from '@angular/router';
import {createErrorHandler} from '@sentry/angular';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {ApiModule, Configuration} from 'finbricks-onebank-public-api';
import {routes} from './app.routes';
import {environment} from '../environments/environment';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(),
    provideRouter(routes),
    {provide: ErrorHandler, useValue: createErrorHandler()},
    importProvidersFrom([
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        },
        defaultLanguage: environment.locale
      }),
      ApiModule.forRoot(
        () => new Configuration({basePath: environment.apiPath})
      )
    ])
  ]
};
